if (!customElements.get('tidies-business-details')) {
  customElements.define('tidies-business-details', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.queue = Promise.resolve();
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-business-toggle]')) {
          const enabled = event.target.checked;
          this.querySelector('[data-business-fields]').hidden = !enabled;
          this.querySelector('[data-business-flag]').value = enabled ? 'Yes' : '';
          if (!enabled) this.querySelectorAll('[data-business-input]').forEach(input => { input.value = ''; });
        }
        this.save();
      });
      this.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.save(), 400);
      });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
    }
    save() {
      const attributes = {};
      this.querySelectorAll('input[name^="attributes["]').forEach(input => {
        const key = input.name.slice(11, -1);
        attributes[key] = input.value.trim();
      });
      this.queue = this.queue.catch(() => {}).then(async () => {
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes })
          });
          if (!response.ok) throw new Error('save');
          this.querySelector('[data-business-status]').textContent = '';
        } catch {
          if (this.isConnected) this.querySelector('[data-business-status]').textContent = this.dataset.error;
        }
      });
    }
  });
}
